import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import React, { Component } from "react";
import { instance } from "../../../Actions/AxiosInstance";
import "./index.css";
import Select from "react-select";
import DrawerHeader from "Component/Headers/drawerHeader";


export default class DeviceDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      devicename:
        this.props.currentdevice && this.props.currentdevice.devicename,
      selectedofficeaddressid: this.props.currentdevice
        ? {
            displayvalue: this.props.currentdevice.officelocationid,
            displayname: this.props.currentdevice.locationname,
          }
        : null,
      errordevice: false,
      open: false,
      menu: null,
      locationlist: this.props.locationlist ? this.props.locationlist : null,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleChange1 = this.handleChange1.bind(this);
    this.onClickAway = this.onClickAway.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onCloseDrawer = this.onCloseDrawer.bind(this);
  }

  handleChange(name, type, e) {
    const errorname = `error${name}`;
    if (type == "text") {
      if (!/[a-zA-Z]/.test(e.target.value)) {
        this.setState({
          [errorname]: true,
          [name]: e.target.value,
        });
      } else {
        this.setState({
          [errorname]: false,
          [name]: e.target.value,
        });
      }
    }
  }

  handleChange1(key, id) {
    this.setState({
      [key]: id,
    });
  }

  onClickAway() {
    this.setState({
      menuopen: false,
    });
  }

  onSave() {
    if (this.state.errordevicename || this.state.devicename == "") {
      this.props.enqueueSnackbar("Please enter device name", {
        variant: "error",
      });
    } else {
      const data = {
        name: this.state.devicename,
        biometricdeviceid: this.props.currentdevice.id,
      };
      const { issaveinprogress } = this.props.SaveInProgressReducer;
      if (!issaveinprogress) {
        this.props.setSaveProgress(true);
      instance
        .post("biometric/checkuniquedevicename", data)
        .then((result) => {
          this.props.removeSaveProgress();
          if (result.data.result[0].isunique) {
            const postdata = {
              devicename: this.state.devicename,
              biometricdeviceid: this.props.currentdevice.id,
              officelocationid: this.state.selectedofficeaddressid.displayvalue,
            };
            instance
              .post("biometric/updatedevicename", postdata)
              .then(() => {
                this.props.enqueueSnackbar("saved successfully", {
                  variant: "success",
                });
                this.props.getDeviceList();
                this.props.closeDrawer();
              })
              .catch((error) => {
              
                this.props.enqueueSnackbar(
                  error.response
                    ? error.response.data.error.message
                    : error.message,
                  { variant: "error" },
                );
              });
          }
        })
        .catch((error) => {
          this.props.removeSaveProgress();
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
      }
    }
  }

  onCloseDrawer() {
    this.props.closeDrawer();
  }

  render() {
    const { currentdevice } = this.props;
    const { issaveinprogress } = this.props.SaveInProgressReducer;
    return (
      <div>
        <div className="formwrapper" tabIndex="1">
        <DrawerHeader
                        header="Device Details"
                        isbackarrow={false}
                        closeDrawer={this.onCloseDrawer}
                    />

         
          <div>
            <div className="manage-account-field">
              <p className="form-input-label">Device Name</p>
              <TextField
                id="outlined-dense"
                margin="dense"
                className="input2"
                variant="outlined"
                placeholder="Device Name"
                onChange={(e) => this.handleChange("devicename", "text", e)}
                value={this.state.devicename}
                maxLength="100"
              />
              {this.state.errordevicename && (
                <p style={{ color: "red" }}>Please enter device name</p>
              )}
            </div>

            <div className="manage-account-field">
              <p className="form-input-label">Device Location</p>
              <Select
                onChange={(id) =>
                  this.handleChange1("selectedofficeaddressid", id)
                }
                className="selectsearch"
                options={this.state.locationlist}
                getOptionLabel={(option) => option.displayname}
                getOptionValue={(option) => option.displayvalue}
                value={this.state.selectedofficeaddressid}
                placeholder="Location"
              />

              {this.state.errordevicename && (
                <p style={{ color: "red" }}>Please enter device name</p>
              )}
            </div>
            <div style={{ float: "right", marginTop: 27 }}>
              <Button className={issaveinprogress ? "btn btn-primary-md-grey" :"btn btn-primary-md-blue" } onClick={this.onSave} 
             disabled={issaveinprogress}
             style={{}}
              >
                SAVE
              </Button>
            </div>
          </div>
          <div style={{ marginTop: 90 }}>
            <Divider />
            <div style={{ marginBottom: 16 }}></div>
            <div>
              <ul className="list2">
                <li className="columlist3">
                  <div style={{ fontWeight: "bold", color: "#000" }}>
                    IP Address
                  </div>
                </li>
                <li className="columlist4">
                  <div>
                    {currentdevice && currentdevice.devicelanip
                      ? currentdevice.devicelanip
                      : "-"}
                  </div>
                </li>
              </ul>
              <ul className="list2">
                <li className="columlist3">
                  <div style={{ fontWeight: "bold", color: "#000" }}>
                    Port
                  </div>
                </li>
                <li className="columlist4">
                  <div>
                    {currentdevice && currentdevice.deviceport
                      ? currentdevice.deviceport
                      : "-"}
                  </div>
                </li>
              </ul>
              <ul className="list2">
                <li className="columlist3">
                  <div style={{ fontWeight: "bold", color: "#000" }}>
                    Firmware
                  </div>
                </li>
                <li className="columlist4">
                  <div>
                    {currentdevice && currentdevice.firmware
                      ? currentdevice.firmware
                      : "-"}
                  </div>
                </li>
              </ul>
              <ul className="list2">
                <li className="columlist3">
                  <div style={{ fontWeight: "bold", color: "#000" }}>
                    Serial Number
                  </div>
                </li>
                <li className="columlist4">
                  <div>
                    {currentdevice && currentdevice.deviceserialnumber
                      ? currentdevice.deviceserialnumber
                      : "-"}
                  </div>
                </li>
              </ul>
              <ul className="list2">
                <li className="columlist3">
                  <div style={{ fontWeight: "bold", color: "#000" }}>
                    Fingerprint
                  </div>
                </li>
                <li className="columlist4">
                  <div>
                    {currentdevice && currentdevice.isfingerprint
                      ? "Yes"
                      : "No"}
                  </div>
                </li>
              </ul>
              <ul className="list2">
                <li className="columlist3">
                  <div style={{ fontWeight: "bold", color: "#000" }}>
                    FaceID
                  </div>
                </li>
                <li className="columlist4">
                  <div>
                    {currentdevice && currentdevice.isfaceid ? "Yes" : "No"}
                  </div>
                </li>
              </ul>
              <ul className="list2">
                <li className="columlist3">
                  <div style={{ fontWeight: "bold", color: "#000" }}>
                    RFID
                  </div>
                </li>
                <li className="columlist4">
                  <div>
                    {currentdevice && currentdevice.isrfid ? "Yes" : "No"}
                  </div>
                </li>
              </ul>
              <ul className="list2">
                <li className="columlist3">
                  <div style={{ fontWeight: "bold", color: "#000" }}>
                    Device direction
                  </div>
                </li>
                <li className="columlist4">
                  <div>
                   
                    {currentdevice && currentdevice.devicedirection
                      ? currentdevice.devicedirection
                      : "-"}
                  </div>
                </li>
              </ul>
              <ul className="list2">
                <li className="columlist3">
                  <div style={{ fontWeight: "bold", color: "#000" }}>
                  Last ping date/time
                  </div>
                </li>
                <li className="columlist4">
                  <div>
                   
                    {currentdevice && currentdevice.devicedirection
                      ? currentdevice.devicedirection
                      : "-"}
                  </div>
                </li>
              </ul>
              <ul className="list2">
                <li className="columlist3">
                  <div style={{ fontWeight: "bold", color: "#000" }}>
                  Added by
                  </div>
                </li>
                <li className="columlist4">
                  <div>
                   
                    {currentdevice && currentdevice.addedbyname
                      ? currentdevice.addedbyname
                      : "-"}
                  </div>
                </li>
              </ul>
              <ul className="list2">
                <li className="columlist3">
                  <div style={{ fontWeight: "bold", color: "#000" }}>
                  Updated by
                  </div>
                </li>
                <li className="columlist4">
                  <div>
                   
                    {currentdevice && currentdevice.updatedbyname
                      ? currentdevice.updatedbyname
                      : "-"}
                  </div>
                </li>
              </ul>

             


            </div>
          </div>
        </div>
      </div>
    );
  }
}
